<div class="w-full pr-10 flex flex-col gap-6 overflow-hidden">
  <div class="flex flex-col gap-4 bg-white p-4 rounded-xl">
    <div
      class="flex gap-2 w-full bg-white items-center"
      [formGroup]="searchForm"
    >
      <img src="../../assets/image/search.svg" alt="" class="" />
      <input
        placeholder="Search Name & IP Here..."
        formControlName="search"
        class="w-full border p-2 rounded-md outline-none"
        (keyup)="onKeyUp($event)"
      />
      <div class="flex items-center gap-2">
        <span>From:</span>
        <input
          type="date"
          placeholder="from"
          class="outline-none flex gap-2 border p-2 rounded-xl"
          [max]="cValue"
          formControlName="startDate"
        />
      </div>
      <div class="flex items-center gap-2">
        <span>To:</span>
        <input
          type="date"
          placeholder="from"
          class="outline-none flex gap-2 border p-2 rounded-xl"
        
          [min]="searchForm.controls['startDate'].value"
          formControlName="endDate"
        />
      </div>
      <app-primary-button (click)="searchApi()">Search</app-primary-button>
      <!-- <select class="w-80 border p-2 rounded-xl">
        <option>Agent ID</option>
        <option>Parent ID</option>
      </select> -->
    </div>
  </div>
  <div
    class="w-full bg-white p-4 rounded-xl flex flex-col px-4 overflow-hidden"
  >
    <table class="w-[100%] text-left h-full overflow-y-auto p-3">
      <tr class="h-8">
        <th class="px-4">Name</th>
        <th class="px-4">Role</th>
        <th class="px-4">IP</th>
        <th class="px-4">Browser</th>
        <th class="px-4 text-nowrap">Login Date</th>
        <!-- <th class="px-4 text-nowrap ">Updated Date</th> -->
      </tr>
      <tr
        *ngFor="let item of loginSessionsTable; let i = index"
        class="h-8"
        [ngStyle]="{
          backgroundColor:
            i % 2 == 0
              ? 'color-mix(in oklch,var(--primary) 10%,transparent)'
              : 'white'
        }"
      >
        <td class="pl-3 px-4">
          {{ item?.userDetail?.name | titlecase }}
        </td>
        <td>{{ item.role.title | titlecase }}</td>
        <td>{{ item.logDetail["x-forwarded-for"] }}</td>
        <td>{{ getBrowserType(item.logDetail["user-agent"]) }}</td>
        <td class="text-nowrap">{{ item.createdAt | date : "short" }}</td>
        <!-- <td>{{ item.updatedAt | date : "dd/MM/yyyy " }}</td> -->
      </tr>
    </table>
    <app-empty-data
      *ngIf="loginSessionsTable?.length < 1"
      class="justify-center align-items-center"
      [imageSource]="'../../assets/blankScreen/support.png'"
      [message]="'No data available'"
    ></app-empty-data>
 
  </div>
  <app-next-preview-button
  [limit]="pagination.limit"
  [currentPage]="pagination.currentPage"
  [totalPage]="totalPage"
  [totalRecords]="totalRecords"
  (next)="nextPage()"
  (previous)="previousPage()"
  (pageChange)="onPageChange($event)"
  (last)="onLast()"
  (first)="onFirst()"
></app-next-preview-button>
</div>
